const e = typeof window < "u" && window.Math == Math ? window : typeof self < "u" && self.Math == Math ? self : Function("return this")();
export {
  e as default
};
//# sourceMappingURL=ponyfillGlobal.mjs.map
